// extracted by mini-css-extract-plugin
export default {"pills":"styles_pills__Ww1B6","container":"styles_container__Aof7E"};